import { AuthorizationRequestData } from 'apex-ui-services'
import { uniq } from 'lodash'

export enum PermissionsEnum {
  AccountRead = 'account.read',
  AlpsRead = 'alps.read',
  AlpsModify = 'alps.modify',
  AlpsSubmit = 'alps.submit',
  AccountTransferAcceptButtonActive = 'account_transfer.UI.acceptbutton.active',
}

export const ALPS: string[] = [
  PermissionsEnum.AlpsRead,
  PermissionsEnum.AlpsModify,
  PermissionsEnum.AlpsSubmit,
]

export const ALL_REQUESTED_PERMISSIONS: string[] = uniq([
  ...ALPS,
  PermissionsEnum.AccountRead,
  PermissionsEnum.AccountTransferAcceptButtonActive,
])

export const convertToAuthRequest = (permissions: string[]) => {
  return permissions.map(permission => {
    return {
      permission,
    } as AuthorizationRequestData
  })
}
